export default __webpack_public_path__ + "static/media/lerman-logos.1fa28f2e.png";